/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import { format } from 'libphonenumber-js';
import Vue from 'vue';
import * as mTypes from '../../mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  tenant: {},
  coordinates: [],
  updated: {},
  error: null,
  account_creation: false,
};

const getters = {
  tenant: state => state.tenant,
  coordinates: state => state.coordinates,
  name: state => (state.tenant ? state.tenant.name : ''),
  selectedTenantId: state => (state.tenant ? state.tenant.id : null),
  error: state => state.error,
  updated: state => state.updated,
  account_creation: state => state.account_creation,
};

const actions = {
  fetch({ commit }, payload) {
    // If it's new form then dont fetch any data
    if (payload.id === 'new') {
      return true;
    }
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/partners/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      }).catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  saveTenant({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let request;
    if (payload.tenant.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/partners/${payload.tenant.id}`, payload.tenant);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/partners/`, payload.tenant);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_STORED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/partners/${payload.id}`)
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  fetchReport({}, payload) {
    return Vue.http.get(`${getApiPath(payload.user)}/partners/${payload.tenant.id}/report`, { data: payload.data });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, tenant) {
    state.tenant = tenant.data;
    state.account_creation = tenant.account_creation;
    state.name = tenant.data.name;
    state.coordinates = [];
    if (state.tenant.phone) {
      state.tenant.phoneNumber = format({ country: state.tenant.phoneCountry, phone: state.tenant.phone.toString() }, 'International_plaintext');
    } else {
      state.tenant.phoneNumber = null;
    }
    /* tenant.data.coordinates.forEach((el) => {
      if (el !== null) {
        state.coordinates.push(el);
      }
    }); */
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.tenant = {};
    state.coordinates = [];
    state.name = '';
    state.error = null;
  },
  [mTypes.DATA_STORED](state, tenant) {
    state.tenant = tenant.data;
    state.updated = tenant.data;
    state.error = null;
    state.name = tenant.data.name;
    state.coordinates = [];
    /* tenant.data.coordinates.forEach((el) => {
      if (el !== null) {
        state.coordinates.push(el);
      }
    }); */
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
  [mTypes.UPDATE_USER](state, account) {
    const index = state.tenant.accounts.findIndex(obj => obj.id === account.id);
    state.tenant.accounts[index] = account;
  },
  [mTypes.ADD_USER](state, account) {
    state.tenant.accounts.push(account);
  },
  [mTypes.REMOVE_USER](state, accountId) {
    const index = state.tenant.accounts.findIndex(obj => obj.id === accountId);
    state.tenant.accounts.splice(index, 1);
  },
  [mTypes.UPDATE_PRODUCT](state, payload) {
    const index = state.tenant.products.findIndex(obj => obj.id === payload.product);
    state.tenant.products[index].issued = payload.amount;
  },
  [mTypes.ADD_PRODUCT](state, payload) {
    if (state.tenant.products) {
      const index = state.tenant.products.findIndex(obj => obj.id === payload.product.id);
      if (index !== -1) {
        state.tenant.products[index] = payload.id;
      }
      state.tenant.products.push(payload.product);
    } else {
      state.tenant = {
        products: payload.products,
      };
    }
  },
  [mTypes.REMOVE_PRODUCT](state, payload) {
    const index = state.tenant.products.findIndex(obj => obj.id === payload.product.id);
    state.tenant.products.splice(index, 1);
  },
  [mTypes.REMOVE_KIOSK](state, kioskId) {
    const index = state.tenant.kiosks.findIndex(obj => obj.id === kioskId);
    state.tenant.kiosks.splice(index, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/tenants/tenant.js